// Русские подписи значений конфигурации пакетов (источник: generator-front)
export const PACK_TYPES = {
  music: 'Музыка',
  movie: 'Кино',
  series: 'Сериалы',
}

export const PACK_STATUSES = {
  new: { label: 'Новый', variant: 'light-primary' },
  pending: { label: 'В очереди', variant: 'light-warning' },
  error: { label: 'Ошибка', variant: 'light-danger' },
  ready: { label: 'Готов', variant: 'light-info' },
  processing: { label: 'Обработка', variant: 'light-secondary' },
  done: { label: 'Завершено', variant: 'light-success' },
}

export const LAYOUTS = {
  simple: 'Простой конфиг раунда',
  preset: 'Пресет пакета',
  round: 'Конфиг раунда',
  all: 'Конфиг всех раундов',
}

export const PACK_PRESETS = {
  melody: 'Угадай мелодию',
  melodyChoice: 'Музыка 1 из 4',
  covers: 'Каверы',
  coverArts: 'Обложки',
  coversAndCoverArts: 'Обложки + Каверы',
  snakes: 'Змейка',
  alphabet: 'Алфавитка',
  frameTriple: 'Угадайка по кадрам (3 кадра)',
  frameSingle: 'Угадайка по кадру',
  movieMix: 'Кино-микс',
  seriesMix: 'Сериальный микс',
}

export const THEME_TYPES = {
  random: 'Рандом',
  any: 'Любая',
  topic: 'Тематика',
  firstLetters: 'Первые буквы',
  matrix: 'Матрица',
  letterCount: 'Число букв',
  country: 'Страна',
  matrixInitials: 'Матрица (инициалы)',
  matrixWordEdges: 'Матрица (края слов)',
  otherNamingTopics: 'Прочие именные темы',
  wordCount: 'Число слов',
  genres: 'Жанры',
  symbolsInTitle: 'Символы в названии',
  prepositionsInTitle: 'Предлоги в названии',
  releaseYear: 'Год релиза',
  actors: 'Актёры',
  directors: 'Режиссёры',
  awards: 'Награды',
  studio: 'Студия',
  foundationYear: 'Год основания',
  snake: 'Змейка',
  fiveLetterWord: '5-буквенное слово',
  ladder: 'Лесенка',
}

// Форматы тем: музыка (pack-formats.js THEME_FORMATS + FINAL_ONLY_FORMATS) и кино (MOVIE_THEME_FORMATS)
export const THEME_FORMATS = {
  melody: 'Угадай мелодию',
  covers: 'Каверы',
  melodyChoice: 'Музыка 1 из 4',
  coverArts: 'Обложки',
  artistPhotos: 'Фото артистов',
  artistPhotosMusic: 'Фото артистов + Песня',
  coverGrid: 'Четыре Обложки',
  coverAcrostic: 'Собери исполнителя по обложкам',
  oddCoverChoice: 'Лишняя обложка (выбор)',
  artistCountryChoice: 'Страна исполнителя (выбор)',
  oddCountryChoice: 'Лишний исполнитель по стране (выбор)',
  olderArtistChoice: 'Кто старше (выбор)',
  olderArtistOrder: 'Артисты по старшинству (мини-игра)',
  portmanteauPhoto: 'Шлакоблокунь (Фото + Песня)',
  portmanteauCoverArt: 'Шлакоблокунь (Обложка + Песня)',
  commonWordPhoto: 'Общее слово (Фото + Песня)',
  commonWordCoverArt: 'Общее слово (Обложка + Песня)',
  nameInNamePhoto: 'Одно в другом (Фото + Песня)',
  nameInNameCoverArt: 'Одно в другом (Обложка + Песня)',
  bandMembers: 'Составы групп',
  trackTitles: 'Исполнитель по трекам',
  gapoifika: 'ГаПоИФиКа по трекам',
  missingConsonants: 'Пропущенные согласные',
  anagram: 'Анаграмма',
  gapoifikaFinal: 'Финал: ГаПоИФиКа — 2 исполнителя',
  triplePortmanteau: 'Финал: Шлакоблокунь из 3 исполнителей',
  tripleCommonWord: 'Финал: Общее слово у 3 исполнителей',
  anagramFinal: 'Финал: Анаграмма — 3 исполнителя',
  frame1: '1 кадр',
  frame2: '2 кадра',
  frame3: '3 кадра',
  oddFrameChoice: 'Лишний кадр (выбор)',
  oddFrameTitle: 'Лишний кадр (название)',
  oddFrameBoth: 'Лишний кадр (оба названия)',
  cast: 'Фильм/Сериал по касту (фото)',
  castNames: 'Фильм/Сериал по касту (имена)',
  castDub: 'Фильм/Сериал по касту (фото, озвучка)',
  castNamesDub: 'Фильм/Сериал по касту (имена, озвучка)',
  directorPosters: 'Режиссёр по фильмам',
  oddDirectorChoice: 'Лишний режиссёр (выбор)',
  movieByActorChoice: 'Фильм/Сериал по актёру (выбор)',
  yearTheme: 'Год + тема',
  franchiseOrder: 'Франшиза по порядку',
  missingMovie: 'Пропущенный фильм',
  episodeList: 'Список эпизодов',
  actorPosters: 'Актёр по фильмам',
  franchisePartChoice: 'Номер во франшизе (выбор)',
  olderMovieChoice: 'Что вышло раньше (выбор)',
  movieYearChoice: 'Год выхода (выбор)',
  sameYear: 'Один год',
  // Старые коды со встроенным «для всех» (остались в конфигах созданных паков)
  oddFrameChoiceForAll: 'Лишний кадр (выбор) — для всех',
  oddDirectorChoiceForAll: 'Лишний режиссёр (выбор) — для всех',
  movieByActorChoiceForAll: 'Фильм/Сериал по актёру (выбор) — для всех',
}

export const CLUSTERS = {
  none: 'Нет',
  rock: 'Рок',
  pop: 'Поп',
  rusrock: 'Русский рок',
  rap: 'Рэп',
  metal: 'Метал',
  folk: 'Фолк',
  // В генераторе подписи нет; название кластера №10 в БД sifnf
  soviet: 'Советские фильмы',
}

export const PRICE_FORMATS = {
  standard: 'Стандартная',
  flatRounds: 'Плоские раунды',
  flatTopics: 'Плоские темы',
}

// Платежи ЮKassa генератора
export const PAYMENT_STATUSES = {
  succeeded: { label: 'Оплачен', variant: 'light-success' },
  pending: { label: 'Ожидает', variant: 'light-warning' },
  canceled: { label: 'Отменён', variant: 'light-secondary' },
  error: { label: 'Ошибка', variant: 'light-danger' },
}

// Типы движений баланса пользователя генератора
export const TRANSACTION_KINDS = {
  payment: { label: 'Пополнение', variant: 'light-success' },
  pack_build: { label: 'Сборка пака', variant: 'light-primary' },
  bonus: { label: 'Бонус', variant: 'light-info' },
  other: { label: 'Прочее', variant: 'light-secondary' },
}
